import { TextValue } from '@shared/interfaces';
import { ReactionResultStatusEnum } from '../_enums';

export const reactionResultStatusNames: Record<ReactionResultStatusEnum, string> = {
    [ReactionResultStatusEnum.ALL]: 'status.all',
    [ReactionResultStatusEnum.ACTION_REQUIRED]: 'order.status.actionRequired',
    [ReactionResultStatusEnum.COMPLETED]: 'order.status.completed',
    [ReactionResultStatusEnum.IN_PROGRESS]: 'order.status.inProgress',
    [ReactionResultStatusEnum.RECEIVED]: 'order.status.received',
    [ReactionResultStatusEnum.SUBMITTED]: 'order.reaction.status.submitted',
    [ReactionResultStatusEnum.CANCELED]: 'order.status.canceled',
    [ReactionResultStatusEnum.CANCELED_FROM_LIMS]: 'order.status.canceledFromLIMS',
};

export const reactionResultStatusTooltips: Record<ReactionResultStatusEnum, string> = {
    [ReactionResultStatusEnum.ALL]: '',
    [ReactionResultStatusEnum.ACTION_REQUIRED]: 'order.results.status.actionRequired.tooltip',
    [ReactionResultStatusEnum.COMPLETED]: 'order.results.status.completed.tooltip',
    [ReactionResultStatusEnum.IN_PROGRESS]: 'order.results.status.inProgress.tooltip',
    [ReactionResultStatusEnum.RECEIVED]: 'order.results.status.received.tooltip',
    [ReactionResultStatusEnum.SUBMITTED]: 'order.results.status.submitted.tooltip',
    [ReactionResultStatusEnum.CANCELED]: 'order.results.status.canceled.tooltip',
    [ReactionResultStatusEnum.CANCELED_FROM_LIMS]: 'order.results.status.canceledFromLIMS.tooltip',
};

export const reactionResultsStatuses: TextValue[] = [
    { value: ReactionResultStatusEnum.ALL, text: reactionResultStatusNames[ReactionResultStatusEnum.ALL] },
    {
        value: ReactionResultStatusEnum.ACTION_REQUIRED,
        text: reactionResultStatusNames[ReactionResultStatusEnum.ACTION_REQUIRED],
    },
    {
        value: ReactionResultStatusEnum.COMPLETED,
        text: reactionResultStatusNames[ReactionResultStatusEnum.COMPLETED],
    },
    {
        value: ReactionResultStatusEnum.IN_PROGRESS,
        text: reactionResultStatusNames[ReactionResultStatusEnum.IN_PROGRESS],
    },
    {
        value: ReactionResultStatusEnum.RECEIVED,
        text: reactionResultStatusNames[ReactionResultStatusEnum.RECEIVED],
    },
    {
        value: ReactionResultStatusEnum.SUBMITTED,
        text: reactionResultStatusNames[ReactionResultStatusEnum.SUBMITTED],
    },
    {
        value: ReactionResultStatusEnum.CANCELED,
        text: reactionResultStatusNames[ReactionResultStatusEnum.CANCELED],
    },
    {
        value: ReactionResultStatusEnum.CANCELED_FROM_LIMS,
        text: reactionResultStatusNames[ReactionResultStatusEnum.CANCELED_FROM_LIMS],
    },
];
